// /**
//  * Minimum Order Quantity Enforcement
//  * Prevents adding to cart if quantity is below minimum
//  */

// (function() {
//   'use strict';
  
//   // Wait for DOM to be ready
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }
  
//   function init() {
//     enforceMinimumOrderQuantity();
//   }
  
//   function enforceMinimumOrderQuantity() {
//     // Find all product forms on the page
//     const productForms = document.querySelectorAll('form[action*="/cart/add"]');
    
//     productForms.forEach(form => {
//       setupFormValidation(form);
//     });
    
//     // Also watch for dynamically loaded forms (quick view, etc.)
//     observeNewForms();
//   }
  
//   function setupFormValidation(form) {
//     // Check if this product has a minimum order quantity
//     const minQtyElement = form.querySelector('[data-min-order-qty]');
    
//     // If no minimum is set, skip this form
//     if (!minQtyElement) return;
    
//     const minQty = parseInt(minQtyElement.getAttribute('data-min-order-qty'));
    
//     // If invalid minimum, skip
//     if (!minQty || minQty < 1) return;
    
//     const qtyInput = form.querySelector('input[name="quantity"]');
    
//     if (!qtyInput) return;
    
//     // Set the HTML5 min attribute on the input
//     qtyInput.setAttribute('min', minQty);
    
//     // Set initial value to minimum if current value is less
//     if (parseInt(qtyInput.value) < minQty) {
//       qtyInput.value = minQty;
//     }
    
//     // Handle minus button clicks
//     handleMinusButton(form, qtyInput, minQty);
    
//     // Handle manual input changes
//     handleInputChanges(qtyInput, minQty);
    
//     // CRITICAL: Prevent form submission if below minimum
//     preventInvalidSubmission(form, qtyInput, minQty);
//   }
  
//   function handleMinusButton(form, qtyInput, minQty) {
//     const minusBtn = form.querySelector('.quantity__button[name="minus"]');
    
//     if (!minusBtn) return;
    
//     minusBtn.addEventListener('click', function(e) {
//       // Use setTimeout to check value after button's default action
//       setTimeout(() => {
//         const currentValue = parseInt(qtyInput.value);
//         if (currentValue < minQty) {
//           qtyInput.value = minQty;
//         }
//       }, 10);
//     });
//   }
  
//   function handleInputChanges(qtyInput, minQty) {
//     // Validate on change
//     qtyInput.addEventListener('change', function() {
//       validateQuantity(this, minQty);
//     });
    
//     // Validate on blur (when user clicks away)
//     qtyInput.addEventListener('blur', function() {
//       validateQuantity(this, minQty);
//     });
    
//     // Validate on input (as user types)
//     qtyInput.addEventListener('input', function() {
//       // Don't validate while typing, just on blur/change
//       // But we can warn with the HTML5 validation
//       if (parseInt(this.value) < minQty && this.value !== '') {
//         this.setCustomValidity(`Minimum order quantity is ${minQty}`);
//       } else {
//         this.setCustomValidity('');
//       }
//     });
//   }
  
//   function validateQuantity(input, minQty) {
//     const currentValue = parseInt(input.value);
    
//     if (isNaN(currentValue) || currentValue < minQty) {
//       input.value = minQty;
//       showNotification(`Minimum order quantity for this product is ${minQty} units`, 'error');
//       return false;
//     }
    
//     input.setCustomValidity('');
//     return true;
//   }
  
//   function preventInvalidSubmission(form, qtyInput, minQty) {
//     // Intercept the form submission
//     form.addEventListener('submit', function(e) {
//       const currentQty = parseInt(qtyInput.value);
      
//       // BLOCK submission if below minimum
//       if (isNaN(currentQty) || currentQty < minQty) {
//         e.preventDefault();
//         e.stopPropagation();
//         e.stopImmediatePropagation();
        
//         // Set value to minimum
//         qtyInput.value = minQty;
        
//         // Show error notification
//         showNotification(
//           `Cannot add to cart. Minimum order quantity is ${minQty} units.`,
//           'error'
//         );
        
//         // Flash the quantity input to draw attention
//         flashInput(qtyInput);
        
//         return false;
//       }
//     }, true); // Use capture phase to intercept early
    
//     // Also intercept any AJAX add-to-cart if theme uses it
//     const addToCartBtn = form.querySelector('[name="add"], [type="submit"]');
//     if (addToCartBtn) {
//       addToCartBtn.addEventListener('click', function(e) {
//         const currentQty = parseInt(qtyInput.value);
        
//         if (isNaN(currentQty) || currentQty < minQty) {
//           e.preventDefault();
//           e.stopPropagation();
//           e.stopImmediatePropagation();
          
//           qtyInput.value = minQty;
//           showNotification(
//             `Cannot add to cart. Minimum order quantity is ${minQty} units.`,
//             'error'
//           );
//           flashInput(qtyInput);
          
//           return false;
//         }
//       }, true);
//     }
//   }
  
//   function flashInput(input) {
//     // Add a flash animation to the input
//     const originalBorder = input.style.border;
//     input.style.transition = 'border 0.3s';
//     input.style.border = '2px solid #ff0000';
    
//     setTimeout(() => {
//       input.style.border = originalBorder;
//     }, 1000);
//   }
  
//   function showNotification(message, type = 'error') {
//     // Remove any existing notification
//     const existingNotification = document.querySelector('.moq-notification');
//     if (existingNotification) {
//       existingNotification.remove();
//     }
    
//     // Create notification element
//     const notification = document.createElement('div');
//     notification.className = 'moq-notification';
    
//     const bgColor = type === 'error' ? '#dc3545' : '#28a745';
    
//     notification.style.cssText = `
//       position: fixed;
//       top: 20px;
//       left: 50%;
//       transform: translateX(-50%);
//       background: ${bgColor};
//       color: white;
//       padding: 16px 24px;
//       border-radius: 8px;
//       box-shadow: 0 4px 12px rgba(0,0,0,0.15);
//       z-index: 10000;
//       font-size: 14px;
//       font-weight: 500;
//       max-width: 90%;
//       text-align: center;
//       animation: slideDown 0.3s ease;
//     `;
    
//     notification.textContent = message;
    
//     // Add animation
//     const style = document.createElement('style');
//     style.textContent = `
//       @keyframes slideDown {
//         from {
//           opacity: 0;
//           transform: translateX(-50%) translateY(-20px);
//         }
//         to {
//           opacity: 1;
//           transform: translateX(-50%) translateY(0);
//         }
//       }
//     `;
//     document.head.appendChild(style);
    
//     document.body.appendChild(notification);
    
//     // Auto-remove after 4 seconds
//     setTimeout(() => {
//       notification.style.transition = 'opacity 0.3s, transform 0.3s';
//       notification.style.opacity = '0';
//       notification.style.transform = 'translateX(-50%) translateY(-20px)';
      
//       setTimeout(() => {
//         notification.remove();
//       }, 300);
//     }, 4000);
//   }
  
//   function observeNewForms() {
//     // Watch for dynamically added forms (quick view, AJAX loading, etc.)
//     const observer = new MutationObserver(mutations => {
//       mutations.forEach(mutation => {
//         mutation.addedNodes.forEach(node => {
//           if (node.nodeType === 1) { // Element node
//             // Check if the node itself is a form
//             if (node.matches && node.matches('form[action*="/cart/add"]')) {
//               setupFormValidation(node);
//             }
//             // Check for forms within the node
//             const forms = node.querySelectorAll ? node.querySelectorAll('form[action*="/cart/add"]') : [];
//             forms.forEach(form => setupFormValidation(form));
//           }
//         });
//       });
//     });
    
//     observer.observe(document.body, {
//       childList: true,
//       subtree: true
//     });
//   }
  
// })();
/**
 * Minimum Order Quantity Enforcement with Step Increments
 * Prevents adding to cart if quantity is below minimum or not in proper increments
 */

// (function() {
//   'use strict';
  
//   // Wait for DOM to be ready
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }
  
//   function init() {
//     enforceMinimumOrderQuantity();
//   }
  
//   function enforceMinimumOrderQuantity() {
//     // Find all product forms on the page
//     const productForms = document.querySelectorAll('form[action*="/cart/add"]');
    
//     productForms.forEach(form => {
//       setupFormValidation(form);
//     });
    
//     // Also watch for dynamically loaded forms (quick view, etc.)
//     observeNewForms();
//   }
  
//   function setupFormValidation(form) {
//     // Check if this product has a minimum order quantity
//     const minQtyElement = form.querySelector('[data-min-order-qty]');
    
//     // If no minimum is set, skip this form
//     if (!minQtyElement) return;
    
//     const minQty = parseInt(minQtyElement.getAttribute('data-min-order-qty'));
    
//     // If invalid minimum, skip
//     if (!minQty || minQty < 1) return;
    
//     const qtyInput = form.querySelector('input[name="quantity"]');
    
//     if (!qtyInput) return;
    
//     // Set the HTML5 min and step attributes
//     qtyInput.setAttribute('min', minQty);
//     qtyInput.setAttribute('step', minQty);
    
//     // Set initial value to minimum if current value is less
//     if (parseInt(qtyInput.value) < minQty) {
//       qtyInput.value = minQty;
//     }
    
//     // Handle plus/minus button clicks
//     handleQuantityButtons(form, qtyInput, minQty);
    
//     // Handle manual input changes
//     handleInputChanges(qtyInput, minQty);
    
//     // CRITICAL: Prevent form submission if invalid quantity
//     preventInvalidSubmission(form, qtyInput, minQty);
//   }
  
//   function handleQuantityButtons(form, qtyInput, minQty) {
//     const minusBtn = form.querySelector('.quantity__button[name="minus"]');
//     const plusBtn = form.querySelector('.quantity__button[name="plus"]');
    
//     if (minusBtn) {
//       minusBtn.addEventListener('click', function(e) {
//         e.preventDefault(); // Prevent default behavior
        
//         const currentValue = parseInt(qtyInput.value);
//         const newValue = currentValue - minQty;
        
//         if (newValue >= minQty) {
//           qtyInput.value = newValue;
//         } else {
//           qtyInput.value = minQty;
//         }
        
//         // Trigger change event
//         qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
//       });
//     }
    
//     if (plusBtn) {
//       plusBtn.addEventListener('click', function(e) {
//         e.preventDefault(); // Prevent default behavior
        
//         const currentValue = parseInt(qtyInput.value);
//         const newValue = currentValue + minQty;
        
//         qtyInput.value = newValue;
        
//         // Trigger change event
//         qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
//       });
//     }
//   }
  
//   function handleInputChanges(qtyInput, minQty) {
//     // Validate on change
//     qtyInput.addEventListener('change', function() {
//       validateAndCorrectQuantity(this, minQty);
//     });
    
//     // Validate on blur (when user clicks away)
//     qtyInput.addEventListener('blur', function() {
//       validateAndCorrectQuantity(this, minQty);
//     });
    
//     // Validate on input (as user types)
//     qtyInput.addEventListener('input', function() {
//       const currentValue = parseInt(this.value);
      
//       if (isNaN(currentValue) || currentValue < minQty) {
//         this.setCustomValidity(`Minimum order quantity is ${minQty}`);
//       } else if (currentValue % minQty !== 0) {
//         this.setCustomValidity(`Quantity must be in multiples of ${minQty}`);
//       } else {
//         this.setCustomValidity('');
//       }
//     });
//   }
  
//   function validateAndCorrectQuantity(input, minQty) {
//     const currentValue = parseInt(input.value);
    
//     // Check if value is empty or invalid
//     if (isNaN(currentValue) || currentValue < minQty) {
//       input.value = minQty;
//       showNotification(`Minimum order quantity for this product is ${minQty} units`, 'error');
//       flashInput(input);
//       return false;
//     }
    
//     // Check if value is a multiple of minQty
//     if (currentValue % minQty !== 0) {
//       // Round to nearest valid multiple
//       const correctedValue = Math.round(currentValue / minQty) * minQty;
//       const finalValue = correctedValue < minQty ? minQty : correctedValue;
      
//       input.value = finalValue;
//       showNotification(`Quantity must be in multiples of ${minQty}. Adjusted to ${finalValue} units.`, 'warning');
//       flashInput(input);
//       return false;
//     }
    
//     input.setCustomValidity('');
//     return true;
//   }
  
//   function preventInvalidSubmission(form, qtyInput, minQty) {
//     // Intercept the form submission
//     form.addEventListener('submit', function(e) {
//       const currentQty = parseInt(qtyInput.value);
      
//       // BLOCK submission if invalid
//       if (isNaN(currentQty) || currentQty < minQty || currentQty % minQty !== 0) {
//         e.preventDefault();
//         e.stopPropagation();
//         e.stopImmediatePropagation();
        
//         // Correct the value
//         const correctedValue = currentQty < minQty ? minQty : (Math.round(currentQty / minQty) * minQty);
//         qtyInput.value = correctedValue;
        
//         // Show error notification
//         showNotification(
//           `Quantity must be in multiples of ${minQty}. Please order ${correctedValue} units.`,
//           'error'
//         );
        
//         flashInput(qtyInput);
        
//         return false;
//       }
//     }, true);
    
//     // Also intercept any AJAX add-to-cart
//     const addToCartBtn = form.querySelector('[name="add"], [type="submit"]');
//     if (addToCartBtn) {
//       addToCartBtn.addEventListener('click', function(e) {
//         const currentQty = parseInt(qtyInput.value);
        
//         if (isNaN(currentQty) || currentQty < minQty || currentQty % minQty !== 0) {
//           e.preventDefault();
//           e.stopPropagation();
//           e.stopImmediatePropagation();
          
//           const correctedValue = currentQty < minQty ? minQty : (Math.round(currentQty / minQty) * minQty);
//           qtyInput.value = correctedValue;
          
//           showNotification(
//             `Quantity must be in multiples of ${minQty}. Please order ${correctedValue} units.`,
//             'error'
//           );
          
//           flashInput(qtyInput);
          
//           return false;
//         }
//       }, true);
//     }
//   }
  
//   function flashInput(input) {
//     const originalBorder = input.style.border;
//     input.style.transition = 'border 0.3s';
//     input.style.border = '2px solid #ff6b6b';
    
//     setTimeout(() => {
//       input.style.border = originalBorder;
//     }, 1000);
//   }
  
//   function showNotification(message, type = 'error') {
//     // Remove any existing notification
//     const existingNotification = document.querySelector('.moq-notification');
//     if (existingNotification) {
//       existingNotification.remove();
//     }
    
//     // Create notification element
//     const notification = document.createElement('div');
//     notification.className = 'moq-notification';
    
//     let bgColor;
//     switch(type) {
//       case 'error':
//         bgColor = '#dc3545';
//         break;
//       case 'warning':
//         bgColor = '#ff9800';
//         break;
//       default:
//         bgColor = '#28a745';
//     }
    
//     notification.style.cssText = `
//       position: fixed;
//       top: 20px;
//       left: 50%;
//       transform: translateX(-50%);
//       background: ${bgColor};
//       color: white;
//       padding: 16px 24px;
//       border-radius: 8px;
//       box-shadow: 0 4px 12px rgba(0,0,0,0.15);
//       z-index: 10000;
//       font-size: 14px;
//       font-weight: 500;
//       max-width: 90%;
//       text-align: center;
//       animation: slideDown 0.3s ease;
//     `;
    
//     notification.textContent = message;
    
//     // Add animation
//     const style = document.createElement('style');
//     style.textContent = `
//       @keyframes slideDown {
//         from {
//           opacity: 0;
//           transform: translateX(-50%) translateY(-20px);
//         }
//         to {
//           opacity: 1;
//           transform: translateX(-50%) translateY(0);
//         }
//       }
//     `;
//     document.head.appendChild(style);
    
//     document.body.appendChild(notification);
    
//     // Auto-remove after 4 seconds
//     setTimeout(() => {
//       notification.style.transition = 'opacity 0.3s, transform 0.3s';
//       notification.style.opacity = '0';
//       notification.style.transform = 'translateX(-50%) translateY(-20px)';
      
//       setTimeout(() => {
//         notification.remove();
//       }, 300);
//     }, 4000);
//   }
  
//   function observeNewForms() {
//     const observer = new MutationObserver(mutations => {
//       mutations.forEach(mutation => {
//         mutation.addedNodes.forEach(node => {
//           if (node.nodeType === 1) {
//             if (node.matches && node.matches('form[action*="/cart/add"]')) {
//               setupFormValidation(node);
//             }
//             const forms = node.querySelectorAll ? node.querySelectorAll('form[action*="/cart/add"]') : [];
//             forms.forEach(form => setupFormValidation(form));
//           }
//         });
//       });
//     });
    
//     observer.observe(document.body, {
//       childList: true,
//       subtree: true
//     });
//   }
  
// })();

/**
 * Minimum Order Quantity Enforcement with Step Increments
 * Prevents adding to cart if quantity is below minimum or not in proper increments
 */

(function() {
  'use strict';
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    enforceMinimumOrderQuantity();
  }
  
  function enforceMinimumOrderQuantity() {
    // Find all product forms on the page
    const productForms = document.querySelectorAll('form[action*="/cart/add"]');
    
    productForms.forEach(form => {
      setupFormValidation(form);
    });
    
    // Also watch for dynamically loaded forms (quick view, etc.)
    observeNewForms();
  }
  
  function setupFormValidation(form) {
    // Check if this product has a minimum order quantity
    const minQtyElement = form.querySelector('[data-min-order-qty]');
    
    // If no minimum is set, skip this form
    if (!minQtyElement) return;
    
    const minQty = parseInt(minQtyElement.getAttribute('data-min-order-qty'));
    
    // If invalid minimum, skip
    if (!minQty || minQty < 1) return;
    
    const qtyInput = form.querySelector('input[name="quantity"]');
    
    if (!qtyInput) return;
    
    // console.log('Setting up MOQ validation. Minimum:', minQty); // Debug log
    
    // Set the HTML5 min and step attributes
    qtyInput.setAttribute('min', minQty);
    qtyInput.setAttribute('step', minQty);
    
    // IMMEDIATELY set initial value to minimum
    qtyInput.value = minQty;
    
    // Handle plus/minus button clicks
    handleQuantityButtons(form, qtyInput, minQty);
    
    // Handle manual input changes
    handleInputChanges(qtyInput, minQty);
    
    // CRITICAL: Prevent form submission if invalid quantity
    preventInvalidSubmission(form, qtyInput, minQty);
  }
  
  function handleQuantityButtons(form, qtyInput, minQty) {
    const minusBtn = form.querySelector('.quantity__button[name="minus"]');
    const plusBtn = form.querySelector('.quantity__button[name="plus"]');
    
    if (plusBtn) {
      plusBtn.addEventListener('click', function(e) {
        // Let default action happen first, then correct
        setTimeout(() => {
          const currentValue = parseInt(qtyInput.value) || minQty;
          
          // If not a valid multiple, round up to next multiple
          if (currentValue % minQty !== 0) {
            const nextMultiple = Math.ceil(currentValue / minQty) * minQty;
            qtyInput.value = nextMultiple;
          } else if (currentValue < minQty) {
            qtyInput.value = minQty;
          }
          
        //   console.log('Plus clicked. New value:', qtyInput.value); // Debug
        }, 10);
      });
    }
    
    if (minusBtn) {
      minusBtn.addEventListener('click', function(e) {
        // Let default action happen first, then correct
        setTimeout(() => {
          const currentValue = parseInt(qtyInput.value) || minQty;
          
          // Don't go below minimum
          if (currentValue < minQty) {
            qtyInput.value = minQty;
          } else if (currentValue % minQty !== 0) {
            // Round down to previous multiple
            const prevMultiple = Math.floor(currentValue / minQty) * minQty;
            qtyInput.value = prevMultiple < minQty ? minQty : prevMultiple;
          }
          
        //   console.log('Minus clicked. New value:', qtyInput.value); // Debug
        }, 10);
      });
    }
  }
  
  function handleInputChanges(qtyInput, minQty) {
    // Validate on change
    qtyInput.addEventListener('change', function() {
      validateAndCorrectQuantity(this, minQty);
    });
    
    // Validate on blur (when user clicks away)
    qtyInput.addEventListener('blur', function() {
      validateAndCorrectQuantity(this, minQty);
    });
  }
  
  function validateAndCorrectQuantity(input, minQty) {
    const currentValue = parseInt(input.value);
    
    // console.log('Validating quantity:', currentValue, 'Min:', minQty); // Debug
    
    // Check if value is empty or invalid
    if (isNaN(currentValue) || currentValue < minQty) {
      input.value = minQty;
      showNotification(`Minimum order quantity for this product is ${minQty} units`, 'error');
      flashInput(input);
      return false;
    }
    
    // Check if value is a multiple of minQty
    if (currentValue % minQty !== 0) {
      // Round to nearest valid multiple
      const correctedValue = Math.round(currentValue / minQty) * minQty;
      const finalValue = correctedValue < minQty ? minQty : correctedValue;
      
      input.value = finalValue;
      showNotification(`Quantity must be in multiples of ${minQty}. Adjusted to ${finalValue} units.`, 'warning');
      flashInput(input);
      return false;
    }
    
    return true;
  }
  
  function preventInvalidSubmission(form, qtyInput, minQty) {
    // Intercept the form submission
    form.addEventListener('submit', function(e) {
      const currentQty = parseInt(qtyInput.value);
      
    //   console.log('Form submit. Quantity:', currentQty, 'Min:', minQty); // Debug
      
      // BLOCK submission if invalid
      if (isNaN(currentQty) || currentQty < minQty || currentQty % minQty !== 0) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        // Correct the value
        const correctedValue = currentQty < minQty ? minQty : (Math.round(currentQty / minQty) * minQty);
        qtyInput.value = correctedValue;
        
        // Show error notification
        showNotification(
          `Quantity must be in multiples of ${minQty}. Please order ${correctedValue} units.`,
          'error'
        );
        
        flashInput(qtyInput);
        
        return false;
      }
    }, true);
    
    // Also intercept any AJAX add-to-cart
    const addToCartBtn = form.querySelector('[name="add"], [type="submit"]');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function(e) {
        const currentQty = parseInt(qtyInput.value);
        
        if (isNaN(currentQty) || currentQty < minQty || currentQty % minQty !== 0) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          const correctedValue = currentQty < minQty ? minQty : (Math.round(currentQty / minQty) * minQty);
          qtyInput.value = correctedValue;
          
          showNotification(
            `Quantity must be in multiples of ${minQty}. Please order ${correctedValue} units.`,
            'error'
          );
          
          flashInput(qtyInput);
          
          return false;
        }
      }, true);
    }
  }
  
  function flashInput(input) {
    const originalBorder = input.style.border;
    input.style.transition = 'border 0.3s';
    input.style.border = '2px solid #ff6b6b';
    
    setTimeout(() => {
      input.style.border = originalBorder;
    }, 1000);
  }
  
  function showNotification(message, type = 'error') {
    // Remove any existing notification
    const existingNotification = document.querySelector('.moq-notification');
    if (existingNotification) {
      existingNotification.remove();
    }
    
    // Create notification element
    const notification = document.createElement('div');
    notification.className = 'moq-notification';
    
    let bgColor;
    switch(type) {
      case 'error':
        bgColor = '#dc3545';
        break;
      case 'warning':
        bgColor = '#ff9800';
        break;
      default:
        bgColor = '#28a745';
    }
    
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: ${bgColor};
      color: white;
      padding: 16px 24px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      z-index: 10000;
      font-size: 14px;
      font-weight: 500;
      max-width: 90%;
      text-align: center;
      animation: slideDown 0.3s ease;
    `;
    
    notification.textContent = message;
    
    // Add animation
    if (!document.querySelector('#moq-animation-style')) {
      const style = document.createElement('style');
      style.id = 'moq-animation-style';
      style.textContent = `
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateX(-50%) translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
        }
      `;
      document.head.appendChild(style);
    }
    
    document.body.appendChild(notification);
    
    // Auto-remove after 4 seconds
    setTimeout(() => {
      notification.style.transition = 'opacity 0.3s, transform 0.3s';
      notification.style.opacity = '0';
      notification.style.transform = 'translateX(-50%) translateY(-20px)';
      
      setTimeout(() => {
        notification.remove();
      }, 300);
    }, 4000);
  }
  
  function observeNewForms() {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            if (node.matches && node.matches('form[action*="/cart/add"]')) {
              setupFormValidation(node);
            }
            const forms = node.querySelectorAll ? node.querySelectorAll('form[action*="/cart/add"]') : [];
            forms.forEach(form => setupFormValidation(form));
          }
        });
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
})();